import React, { Fragment, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useAuth } from "../context/AuthContext";

const AvailabilityUserNoteEditor = ({ user, onUpdated = null }) => {
  const { authAxios } = useAuth();
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [hasStoredNote, setHasStoredNote] = useState(false);

  useEffect(() => {
    if (!user?.id) {
      setNote("");
      setHasStoredNote(false);
      return;
    }

    const fetchNote = async () => {
      try {
        setLoading(true);
        const response = await authAxios().get(
          "/api/backoffice/availability/user_note",
          { params: { user_id: user.id } },
        );
        const fetchedNote = response.data?.note || "";
        setNote(fetchedNote);
        setHasStoredNote(fetchedNote.trim() !== "");
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("Error fetching availability user note");
        console.log(error);
        console.log(error.stack);
      }
    };

    fetchNote();
  }, [authAxios, user?.id]);

  const saveNote = async () => {
    if (!user?.id || note.trim() === "") return;

    try {
      setSaving(true);
      const response = await authAxios().post(
        "/api/backoffice/availability/user_note",
        {
          userId: user.id,
          note: note.trim(),
        },
      );
      setNote(response.data?.note || "");
      setHasStoredNote(true);
      if (onUpdated !== null) onUpdated();
      setSaving(false);
    } catch (error) {
      setSaving(false);
      console.log("Error saving availability user note");
      console.log(error);
      console.log(error.stack);
    }
  };

  const clearNote = async () => {
    if (!user?.id) return;

    try {
      setSaving(true);
      await authAxios().post(
        "/api/backoffice/availability/user_note_clear",
        {},
        { params: { user_id: user.id } },
      );
      setNote("");
      setHasStoredNote(false);
      if (onUpdated !== null) onUpdated();
      setSaving(false);
    } catch (error) {
      setSaving(false);
      console.log("Error clearing availability user note");
      console.log(error);
      console.log(error.stack);
    }
  };

  return (
    <Fragment>
      <h5 className={"text-axis-offblack mt-4"}>Global Availability Notes</h5>
      <Form.Group controlId={"availabilityUserNote"}>
        <Form.Control
          as={"textarea"}
          rows={6}
          value={note}
          disabled={loading || !user?.id}
          onChange={(e) => setNote(e.target.value)}
          placeholder={"Add a persistent availability note for this user"}
        />
      </Form.Group>
      <Row className={"mt-3 g-2"}>
        <Col xs={"auto"}>
          <Button
            variant={"outline-offblack"}
            onClick={saveNote}
            disabled={loading || saving || !user?.id || note.trim() === ""}
          >
            Save Note
          </Button>
        </Col>
        <Col xs={"auto"}>
          <Button
            variant={"outline-danger"}
            onClick={clearNote}
            disabled={loading || saving || !user?.id || !hasStoredNote}
          >
            Clear Note
          </Button>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AvailabilityUserNoteEditor;
